import { useEffect, useState } from 'react';

import './comment.scss';

interface CommentProps {
	defaultValue?: string | null;
	disabled?: boolean;
	className?: string;
	style?: Record<string, string>;
	onChange: (text: string) => void;
	onBlur?: (value: string) => void;
}

export default function Comment({ defaultValue, disabled, onChange, onBlur, className, style }: CommentProps) {
	const [input, setInput] = useState<string | undefined>(defaultValue ?? undefined);

	useEffect(() => {
		setInput(defaultValue ?? undefined);
	}, [defaultValue]);

	const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		setInput(e.target.value);
		onChange(e.target.value);
	};

	return (
		<div className={`comment ${className}`} style={style}>
			<textarea
				value={input}
				disabled={disabled}
				style={{ resize: 'none', width: '100%' }}
				placeholder={'Комментарий...'}
				onChange={e => {
					handleChange(e);
				}}
				onBlur={() => onBlur?.(input ?? '')}
			/>
		</div>
	);
}
